/* eslint-env browser */

'use strict';

const asyncInitializer = require('../initializers/async_initializer');
const getBaseAsyncFiles = require('./base');

const init = (payload, done) => {
  const modulePromises = getBaseAsyncFiles(payload);

  if (window.storePayload) {
    modulePromises.push(
      import(
        /* webpackChunkName: "preact_component" */ '../../../../modules/preact_render_client/desktop'
      )
    );
  } else if (payload.loadSwitch.shouldLoadLazyLoadMerchantLocations) {
    modulePromises.push(
      import(/* webpackChunkName: "g_map" */ './loaders/g_map')
    );
  }

  if (payload.liveChat) {
    modulePromises.push(
      import(/* webpackChunkName: "live_chat" */ './loaders/live_chat')
    );
  }

  if (
    payload.loadSwitch &&
    payload.loadSwitch.shouldShowTipWidget &&
    payload.tipWidgetV2
  ) {
    if (payload.tipWidgetV2.isTripAdvisorReviews) {
      modulePromises.push(
        import(
          /* webpackChunkName: "tip_widget_v2_trip_advisor" */ './loaders/tip_widget_v2_trip_advisor'
        )
      );
    } else {
      modulePromises.push(
        import(
          /* webpackChunkName: "tip_widget_v2" */ './loaders/tip_widget_v2'
        )
      );
    }
  }

  if (
    !payload.carouselV2 &&
    payload.ugcPhotos &&
    payload.ugcPhotos.ids.length
  ) {
    modulePromises.push(
      import(/* webpackChunkName: "ugc_photos" */ './loaders/ugc_photos')
    );
  }

  if (payload.onlineBooking && payload.onlineBooking.widgetType) {
    modulePromises.push(
      import(
        /* webpackChunkName: "online_booking_widget" */ './loaders/online_booking'
      )
    );
  }

  asyncInitializer(modulePromises, 40 * 1000, initStart => {
    if (
      typeof window.BOOMR !== 'undefined' &&
      typeof window.BOOMR.addVar === 'function'
    ) {
      window.BOOMR.addVar(
        'deal_page_async_modules_loaded',
        new Date() - initStart
      );
    }
  });

  return done();
};

module.exports = { init };
